import { Button, type SxProps, type Theme } from "@mui/material";
import { Link } from "react-router-dom";

interface LinkButtonCellProps {
  to: string;
  label: string;
  sx?: SxProps<Theme>;
}

const LinkButtonCell = ({ to, label, sx }: LinkButtonCellProps) => {
  return (
    <Button
      component={Link}
      to={to}
      variant="outlined"
      size="small"
      onClick={(e) => e.stopPropagation()}
      sx={{
        color: "text.primary",
        borderColor: "text.primary",
        whiteSpace: "nowrap",
        "&:hover": {
          backgroundColor: "text.primary",
          borderColor: "text.primary",
          color: "background.paper",
        },
        ...sx,
      }}
    >
      {label}
    </Button>
  );
};

export default LinkButtonCell;
